module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-45-6905732768164b875597db67a25a9ae0.svg";